import { navigate } from 'gatsby'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { ApolloProvider } from '@apollo/client'
import { setDefaultLocale } from 'react-datepicker'
import ja from 'date-fns/locale/ja'
import * as config from './src/config'
import store, { persistor } from './src/store/store'
import { client } from './src/apolloClient/ApolloProvider'
import { Auth0Provider } from './src/lib/auth'
import { AppVersion, SessionCheck } from './src/components/Share'

setDefaultLocale(ja)

const onRedirectCallback = (appState) => {
  // Use Gatsby's navigate method to replace the url
  navigate(appState?.returnTo || '/callback', { replace: true })
}

export const wrapPageElement = ({ element, props }) => {
  return (
    <>
      <AppVersion />
      <SessionCheck>{element}</SessionCheck>
    </>
  )
}

export const wrapRootElement = ({ element }) => {
  return (
    <Auth0Provider
      domain={config.auth0.domain}
      clientId={config.auth0.clientId}
      redirectUri={config.auth0.redirectUri}
      audience={config.auth0.audience}
      responseType="token id_token"
      scope="openid profile email"
      cacheLocation="localstorage"
      useCookiesForTransactions={true}
      useFormData={true}
      onRedirectCallback={onRedirectCallback}
    >
      <ApolloProvider client={client}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            {element}
          </PersistGate>
        </Provider>
      </ApolloProvider>
    </Auth0Provider>
  )
}

// export const onRenderBody = ({ setHeadComponents }) => {
//   setHeadComponents([
//     <link
//       key="leaflet-css"
//       rel="stylesheet"
//       // href="https://unpkg.com/leaflet@1.7.1/dist/leaflet.css"
//       href={styleLeaflet}
//       type="text/css"
//     />,
//   ])
// }
